var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M8.1,6.346a.4.4,0,0,1,.4.4v5.6a.4.4,0,1,1-.8,0v-5.6A.4.4,0,0,1,8.1,6.346Zm-1.6,1.2a.4.4,0,0,1,.4.4v3.2a.4.4,0,0,1-.8,0v-3.2A.4.4,0,0,1,6.5,7.546Zm-1.6.8a.4.4,0,0,1,.4.4v1.6a.4.4,0,1,1-.8,0v-1.6A.4.4,0,0,1,4.9,8.346Z",
    transform: "translate(-4.5 -6.346)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M3.6,0A.39.39,0,0,1,4,.379V5.691a.4.4,0,0,1-.8,0V.379A.39.39,0,0,1,3.6,0ZM2,1.138a.39.39,0,0,1,.4.379V4.553a.39.39,0,0,1-.4.379.39.39,0,0,1-.4-.379V1.518A.39.39,0,0,1,2,1.138ZM.4,1.9a.39.39,0,0,1,.4.379V3.794a.39.39,0,0,1-.4.379A.39.39,0,0,1,0,3.794V2.276A.39.39,0,0,1,.4,1.9Z",
    transform: "translate(21 6.07) rotate(180)",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic",
    transform: "translate(4 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M3.65,6.5a.638.638,0,0,1,.65.625v1.25a5.1,5.1,0,0,0,5.2,5,5.1,5.1,0,0,0,5.2-5V7.125a.651.651,0,0,1,1.3,0v1.25a6.348,6.348,0,0,1-5.85,6.219v2.531h3.9a.625.625,0,1,1,0,1.25H4.95a.625.625,0,1,1,0-1.25h3.9V14.594A6.348,6.348,0,0,1,3,8.375V7.125A.638.638,0,0,1,3.65,6.5Z",
    transform: "translate(-3 1.625)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M8.9,0A3.827,3.827,0,0,0,5,3.75V10a3.827,3.827,0,0,0,3.9,3.75A3.827,3.827,0,0,0,12.8,10V3.75A3.827,3.827,0,0,0,8.9,0Z",
    transform: "translate(-2.4 0)",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic_active.4cff7401294597c6d640e7336fc04976.svg";